import InteractiveAnnotation from "./interactiveAnnotation";
import SegmentChain from "./segmentChain";

export default class FreeHand extends InteractiveAnnotation {
  constructor(position, options) {
    super(position, options);
    this.chain = new SegmentChain(position, options);
  }

  draw(ctx) {
    this.chain.draw(ctx);
    if (this.chain.active && !this.chain.drawingInitialLine) this.chain.drawBoundingBox(ctx);
  }

  isInBounds(x, y){
    return this.chain.isOnLines(x, y);
  }

  mousedown(x, y) {
    this.chain.mousedown(x, y);
    this.signalReady();
  }

  mousemove(x, y) {
    this.chain.mousemove(x, y);
    this.signalReady();
  }

  mouseup() {
    this.chain.mouseup();
    this.signalReady();
  }

  deactivate() {
    this.chain.deactivate();
    this.signalReady();
  }
  
  setLineWidth(width) {
    this.chain.setLineWidth(width);
    this.signalReady();
  }

  updateColor(color) 
  {
    this.chain.color = color;
    this.color = color;
  }
}